import React, { useState, useEffect } from 'react';
import { Layout, Avatar, Typography, Button } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { LimsNavIcon } from '../components/LimsNavIcon';
import { STAFF_CONSOLE_LOGIN_PATH } from './staffConsolePaths';
import '../components/TopNavbar.css';

const { Header } = Layout;
const { Text } = Typography;

interface PlatformAdminTopNavbarProps {
  onToggleSidebar?: () => void;
}

/**
 * 平台管理顶栏：视觉对齐实验室 TopNavbar。
 */
const PlatformAdminTopNavbar: React.FC<PlatformAdminTopNavbarProps> = ({ onToggleSidebar }) => {
  const { logout, username, realName } = useAuth();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleLogout = () => {
    logout();
    navigate(STAFF_CONSOLE_LOGIN_PATH);
  };

  return (
    <Header className="lims-top-navbar top-navbar">
      <div className="lims-top-inner">
        <div className="lims-top-left">
          {isMobile && (
            <Button
              type="text"
              className="lims-mobile-menu"
              icon={<LimsNavIcon name="menu" sizePx={22} />}
              onClick={onToggleSidebar}
            />
          )}
          <Button type="text" className="lims-team-switcher" style={{ maxWidth: isMobile ? 140 : 280 }}>
            <LimsNavIcon name="admin_panel_settings" sizePx={20} className="lims-team-switcher-icon" />
            {!isMobile && <span className="lims-team-switcher-name">平台管理后台</span>}
          </Button>
        </div>

        {!isMobile && (
          <div className="lims-top-center">
            <div className="lims-global-search" style={{ opacity: 0.55, pointerEvents: 'none' }}>
              <LimsNavIcon name="search" sizePx={18} className="lims-global-search-icon" />
              <input
                type="search"
                className="lims-global-search-input"
                placeholder="平台治理 · 团队 / 商家 / 反馈"
                disabled
                aria-label="平台管理搜索占位"
              />
            </div>
          </div>
        )}

        <div className="lims-top-right">
          {!isMobile ? (
            <div className="lims-user-block">
              <Avatar
                size={32}
                icon={<LimsNavIcon name="shield_person" sizePx={18} />}
                style={{
                  backgroundColor: 'rgba(0, 53, 95, 0.1)',
                  color: 'var(--lims-primary)'
                }}
              />
              <div className="lims-user-meta">
                <Text strong style={{ fontSize: 14, color: 'var(--lims-on)' }}>
                  {realName || username || '管理员'}
                </Text>
                <Text style={{ fontSize: 12, color: 'var(--lims-on-variant)' }}>超级管理员</Text>
              </div>
            </div>
          ) : (
            <Avatar
              size={32}
              icon={<LimsNavIcon name="shield_person" sizePx={18} />}
              style={{ backgroundColor: 'rgba(0, 53, 95, 0.1)' }}
            />
          )}

          <Button
            type="text"
            className="lims-logout"
            icon={<LimsNavIcon name="logout" sizePx={20} />}
            onClick={handleLogout}
          >
            {!isMobile && '退出'}
          </Button>
        </div>
      </div>
    </Header>
  );
};

export default PlatformAdminTopNavbar;
